/**
 * Keeps the Pify "Size Chart" app-block button (and any of its trigger
 * elements) in sync with the site's light/dark toggle. The app renders
 * its own markup with its own colors, so we can't edit it directly —
 * instead we find its wrapper and force its trigger element(s) to match
 * the current theme colors, re-applying whenever the toggle fires.
 */
(function () {
  function colorsFor(mode) {
    return mode === 'dark'
      ? { bg: '#0d0d0d', fg: '#f7f5f0', border: 'rgba(255,255,255,0.35)' }
      : { bg: '#ffffff', fg: '#16140f', border: 'rgba(0,0,0,0.35)' };
  }

  function currentMode() {
    return document.documentElement.getAttribute('data-zb-site-theme') === 'dark' ? 'dark' : 'light';
  }

  function styleEl(el, c) {
    el.style.setProperty('background-color', c.bg, 'important');
    el.style.setProperty('color', c.fg, 'important');
    el.style.setProperty('border-color', c.border, 'important');
    el.style.setProperty(
      'transition',
      'background-color .25s ease, color .25s ease, border-color .25s ease',
      'important'
    );
  }

  function findRoot() {
    return (
      document.getElementById('shopify-block-pify_size_charts_size_chart_inline_button_BBQtE6') ||
      document.querySelector('[id*="pify" i]') ||
      document.querySelector('[class*="pify" i]')
    );
  }

  function apply() {
    var root = findRoot();
    if (!root) return false;

    var mode = currentMode();
    var c = colorsFor(mode);
    var clickable = root.querySelectorAll('button, a, [role="button"], summary');
    if (!clickable.length) return false;

    clickable.forEach(function (el) {
      styleEl(el, c);
    });
    return true;
  }

  document.addEventListener('zb:theme-changed', function () {
    apply();
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (apply()) return;

    // The app block can render asynchronously — watch briefly for it,
    // then stop observing once found (or after a short timeout) so we
    // aren't paying a continuous DOM-observation cost site-wide.
    var observer = new MutationObserver(function () {
      if (apply()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, 8000);
  });
})();
